import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink, Newspaper } from 'lucide-react';

const mediaArticles = [
  {
    id: 1,
    title: "The Future of Narratives: Rose AV Ventures into Audio Storytelling with the Launch of RosePod",
    source: "UNI India",
    url: "https://www.uniindia.com/the-future-of-narratives-rose-av-ventures-into-audio-storytelling-with-the-launch-of-rosepod/business-economy/news/3126415.html",
    category: "Launch"
  },
  {
    id: 2,
    title: "RosePod Launches The Filmy Hustle Podcast: A Deep Dive into the Art of Filmmaking",
    source: "Media Infoline",
    url: "https://www.mediainfoline.com/brand/rosepod-launches-the-filmy-hustle-podcast-a-deep-dive-into-the-art-of-filmmaking",
    category: "The Filmy Hustle"
  },
  {
    id: 3,
    title: "The Shift from Traditional Cinema to OTT and Digital-First Formats",
    source: "Brand Equity - Economic Times",
    url: "https://brandequity.economictimes.indiatimes.com/news/media/the-shift-from-traditional-cinema-to-ott-and-digital-first-formats/124779064",
    category: "Industry"
  },
  {
    id: 4,
    title: "Cup of Laughs as RosePod Bowls Out New Cricket Comedy Podcast",
    source: "Indian Television",
    url: "https://www.indiantelevision.com/mam/marketing/brands/cup-of-laughs-as-rosepod-bowls-out-new-cricket-comedy-podcast-251015",
    category: "Two Boys One Cup"
  },
  {
    id: 5,
    title: "Sonali Bendre Exclusive on The Happy Pawdcast 2: Post Cancer Recovery & Parenthood",
    source: "News18",
    url: "https://www.news18.com/videos/movies/sonali-bendre-exclusive-on-the-happy-pawdcast-2-post-cancer-recovery-parenthood-son-ranveern18v-9683903.html",
    category: "The Happy Pawdcast"
  },
  {
    id: 6,
    title: "Sonali Bendre on Season 2 of The Happy Pawdcast: This Community is Finding its Voice",
    source: "CNBC TV18",
    url: "https://www.cnbctv18.com/entertainment/sonali-bendre-on-season-2-of-the-happy-pawdcast-this-community-is-finding-its-voice-ws-l-19744752.htm/amp",
    category: "The Happy Pawdcast"
  },
  {
    id: 7,
    title: "Sonali Bendre Says Nobody is a Born Good Pet Parent as The Happy Pawdcast 2 Begins",
    source: "ANI News",
    url: "https://www.aninews.in/news/entertainment/bollywood/sonali-bendre-says-nobody-is-a-born-good-pet-parent-as-the-happy-pawdcast-2-begins20251129014543/",
    category: "The Happy Pawdcast"
  },
  {
    id: 8,
    title: "Exclusive: Sonali Bendre on Season Two of Her The Happy Pawdcast",
    source: "Firstpost",
    url: "https://www.firstpost.com/entertainment/exclusive-sonali-bendre-on-season-two-of-her-the-happy-pawdcast-we-will-have-professionals-who-will-talk-about-how-to-run-shelters-for-pets-and-13948900.html/amp",
    category: "The Happy Pawdcast"
  },
  {
    id: 9,
    title: "Sonali Bendre Recalls Starting Work at 15, Talks About Exploring New Venture",
    source: "Times Now",
    url: "https://www.timesnownews.com/entertainment-news/bollywood/sonali-bendre-recalls-starting-work-at-15-talks-about-exploring-new-venture-after-son-went-to-university-exclusive-article-153115796/amp",
    category: "The Happy Pawdcast"
  },
  {
    id: 10,
    title: "Sonali Bendre: Icy Could Sense My Immense Pain, She Slept on My Legs Every Night During Cancer Recovery",
    source: "Moneycontrol",
    url: "https://www.moneycontrol.com/entertainment/bollywood/sonali-bendre-icy-could-sense-my-immense-pain-she-slept-on-my-legs-every-night-during-cancer-recovery-exclusive-article-13660628.html",
    category: "The Happy Pawdcast"
  },
  {
    id: 11,
    title: "Sonali Bendre Interview: The Happy Pawdcast Season 2 - Actress Speaks on Pet Parenting",
    source: "ABP Live",
    url: "https://www.abplive.com/entertainment/ott/sonali-bendre-interview-reagarding-her-podcast-the-happy-pawdcast-season-2-actress-speaks-on-pet-parenting-3039597/amp",
    category: "The Happy Pawdcast"
  },
  {
    id: 12,
    title: "सोनाली बेंद्रे ने बताया पेट पैरेंटिंग का अनुभव",
    source: "Dainik Bhaskar",
    url: "https://dainik.bhaskar.com/H9ccjJLmWXb",
    category: "The Happy Pawdcast"
  },
  {
    id: 13,
    title: "RosePod Bows in with Two Boys One Cup Podcast: Where Every Cup Has a Story",
    source: "Passionate in Marketing",
    url: "https://www.passionateinmarketing.com/rosepod-bows-in-with-two-boys-one-cup-podcast-where-every-cup-has-a-story/",
    category: "Two Boys One Cup"
  },
  {
    id: 14,
    title: "Sonali Bendre Returns with The Happy Pawdcast S2 on Rosepod",
    source: "Adgully",
    url: "https://www.adgully.com/post/8713/sonali-bendre-returns-with-the-happy-pawdcast-s2-on-rosepod",
    category: "The Happy Pawdcast"
  },
  {
    id: 15,
    title: "Sonali Bendre Brings Back The Happy Pawdcast",
    source: "Indian Television",
    url: "https://www.indiantelevision.com/mam/podcasts/sonali-bendre-brings-back-the-happy-pawdcast-251104",
    category: "The Happy Pawdcast"
  },
  {
    id: 16,
    title: "Sonali Bendre's The Happy Pawdcast Returns for Season 2: Gulshan Devaiah, Amala Akkineni Among Guests",
    source: "The Week",
    url: "https://www.theweek.in/news/entertainment/2025/11/03/sonali-bendre-s-the-happy-pawdcast-returns-for-season-2-gulshan-devaiah-amala-akkineni-among-guests.html",
    category: "The Happy Pawdcast"
  },
  {
    id: 17,
    title: "Sonali Bendre Returns with Happy Pawdcast, Talks Real Pet Parenting",
    source: "Awaz The Voice",
    url: "https://www.awazthevoice.in/entertainment-news/sonali-bendre-returns-with-happy-pawdcast-talks-real-pet-parenting-44336.html",
    category: "The Happy Pawdcast"
  },
  {
    id: 18,
    title: "Sonali Bendre: The Happy Pawdcast",
    source: "Indian Broadcasting World",
    url: "https://www.indianbroadcastingworld.com/sonali-bendre-the-happy-pawdcast/",
    category: "The Happy Pawdcast"
  },
  {
    id: 19,
    title: "Sonali Bendre Returns with The Happy Pawdcast Season 2: Celebrating Responsible Pet Parenting",
    source: "Filmibeat",
    url: "https://www.filmibeat.com/bollywood/viral/2025/sonali-bendre-returns-with-the-happy-pawdcast-season-2-celebrating-responsible-pet-parenting-and-c-487031.html",
    category: "The Happy Pawdcast"
  },
  {
    id: 20,
    title: "Sonali Bendre Returns with Her Podcast The Happy Pawdcast for Its 2nd Season",
    source: "Gulf Today",
    url: "https://www.gulftoday.ae/culture/2025/11/04/sonali-bendre-returns-with-her-podcast-the-happy-pawdcast-for-its-2nd-season",
    category: "The Happy Pawdcast"
  },
  {
    id: 21,
    title: "Sonali Bendre on Her Passion Project The Happy Pawdcast and What Being a Pet Parent Means to Her",
    source: "T2 Online",
    url: "https://t2online.in/screen/streaming/sonali-bendre-on-her-passion-project-the-happy-pawdcast-and-what-being-a-pet-parent-means-to-her/2002539",
    category: "The Happy Pawdcast"
  },
  {
    id: 22,
    title: "Dogs Have So Much Empathy - Sonali Bendre on The Happy Pawdcast",
    source: "Bollywood Hungama",
    url: "https://www.bollywoodhungama.com/videos/celeb-interviews/sonali-bendre-dogs-have-so-much-empathy-the-happy-pawdcast/",
    category: "The Happy Pawdcast"
  },
  {
    id: 23,
    title: "Sonali Bendre is Spreading Happiness Through The Happy Podcast",
    source: "Dainik Bhaskar",
    url: "https://www.bhaskar.com/entertainment/bollywood/news/sonali-bendre-is-spreading-happiness-through-the-happy-podcast-136310013.html",
    category: "The Happy Pawdcast"
  },
];

const categories = ["All", "Launch", "The Happy Pawdcast", "Two Boys One Cup", "The Filmy Hustle", "Industry"];

const MediaPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    setIsLoaded(true);
    window.scrollTo(0, 0);
  }, []);

  const logoUrl = "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/bdhzg2gi_Rosepod%20logo%20white%20color.png";

  const filteredArticles = selectedCategory === "All" 
    ? mediaArticles 
    : mediaArticles.filter(article => article.category === selectedCategory);

  return (
    <div className="min-h-screen bg-[#04101C]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-40 bg-[#04101C]/90 backdrop-blur-lg border-b border-[#00C4CC]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <Link to="/" className="hover:opacity-80 transition-opacity">
              <img src={logoUrl} alt="Rosepod" className="h-10 md:h-12 w-auto" />
            </Link>
            <Link
              to="/"
              className="flex items-center gap-2 text-[#F5FDFF]/70 hover:text-[#00E08F] transition-colors"
            >
              <ArrowLeft size={20} />
              <span className="hidden sm:inline">Back to Home</span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 relative overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-[#00C4CC]/10 rounded-full blur-[150px]" />
          <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-[#00E08F]/10 rounded-full blur-[120px]" />
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#00C4CC]/10 border border-[#00C4CC]/30 mb-6 transition-all duration-700 ${
                isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <Newspaper size={16} className="text-[#00E08F]" />
              <span className="text-[#00E08F] text-sm font-medium">Press Coverage</span>
            </div>
            <h1
              className={`text-4xl sm:text-5xl md:text-6xl font-bold text-[#F5FDFF] mb-6 transition-all duration-700 ${
                isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              In The <span className="bg-gradient-to-r from-[#00C4CC] via-[#00E08F] to-[#FFF7AE] bg-clip-text text-transparent">Media</span>
            </h1>
            <p
              className={`text-[#F5FDFF]/60 text-lg max-w-2xl mx-auto transition-all duration-700 delay-200 ${
                isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              News, features, and stories about RosePod from leading publications.
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 relative z-10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className={`flex flex-wrap justify-center gap-3 transition-all duration-700 delay-300 ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-[#00C4CC] to-[#00E08F] text-[#04101C]'
                    : 'bg-[#F5FDFF]/5 text-[#F5FDFF]/70 hover:bg-[#F5FDFF]/10 hover:text-[#F5FDFF] border border-[#F5FDFF]/10'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-12 relative z-10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredArticles.map((article, index) => (
              <a
                key={article.id}
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`group block bg-[#0a1a2e] rounded-2xl overflow-hidden border border-[#00C4CC]/10 hover:border-[#00E08F]/50 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_0_30px_rgba(0,224,143,0.15)] ${
                  isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
                }`}
                style={{ transitionDelay: `${index * 50}ms` }}
              >
                {/* Category Badge */}
                <div className="px-6 pt-6">
                  <span className="inline-block px-3 py-1 rounded-full bg-[#00C4CC]/10 text-[#00E08F] text-xs font-medium">
                    {article.category}
                  </span>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-[#F5FDFF] font-semibold text-lg mb-3 group-hover:text-[#00E08F] transition-colors line-clamp-3">
                    {article.title}
                  </h3>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-[#F5FDFF]/50 text-sm">{article.source}</span>
                    <ExternalLink size={16} className="text-[#00C4CC] group-hover:text-[#00E08F] transition-colors" />
                  </div>
                </div>

                {/* Hover Gradient Line */}
                <div className="h-1 bg-gradient-to-r from-[#00C4CC] via-[#00E08F] to-[#FFF7AE] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
              </a>
            ))}
          </div>

          {/* No Results */}
          {filteredArticles.length === 0 && (
            <div className="text-center py-16">
              <p className="text-[#F5FDFF]/50">No articles found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 border-t border-[#F5FDFF]/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#F5FDFF]/40 text-sm">
            © 2025 Rosepod. All rights reserved.
          </p>
        </div>
      </footer>

      <style>{`
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default MediaPage;
